export const flatQuery = ({ edges = [] }) =>
  edges.map(({ node }) => ({ ...node }))

export default {
  flatQuery,
}
